export interface CultureInfo {
    readonly locale: string;
    readonly languageCode: string;
    readonly englishName: string;
    readonly localName: string;
    readonly rtl?: boolean;
    readonly dateFnsName: string;
    readonly showSellerHelp: boolean;
    readonly showBuyerHelp: boolean;
    dateFnsImport(): Promise<any>;
}

function cultureFilter(culture: CultureInfo) {
    if (['he-IL'].includes(culture.locale) && !['Development', 'Test', 'UAT'].includes(window.APP_CONFIG.ENVIRONMENT)) {
        return false;
    }

    return true;
}

const SupportedCultures: readonly CultureInfo[] = [
    {
        locale: 'en-GB',
        languageCode: 'en',
        englishName: 'English',
        localName: 'English',
        dateFnsName: 'en-GB',
        showSellerHelp: true,
        showBuyerHelp: true,
        dateFnsImport: async () => (await import('date-fns/locale/en-GB')).enGB,
    },
    {
        locale: 'de-DE',
        languageCode: 'de',
        englishName: 'German',
        localName: 'Deutsch',
        dateFnsName: 'de-DE',
        showSellerHelp: true,
        showBuyerHelp: true,

        dateFnsImport: async () => (await import('date-fns/locale/de')).de,
    },
    {
        locale: 'nb-NO',
        languageCode: 'nb',
        englishName: 'Norwegian',
        localName: 'Norsk',
        dateFnsName: 'nb',
        showSellerHelp: true,
        showBuyerHelp: true,

        dateFnsImport: async () => (await import('date-fns/locale/nb')).nb,
    },
    {
        locale: 'he-IL',
        languageCode: 'he',
        englishName: 'Hebrew',
        localName: 'עברית',
        rtl: true,
        dateFnsName: 'he',
        showSellerHelp: false,
        showBuyerHelp: false,

        dateFnsImport: async () => (await import('date-fns/locale/he')).he,
    },
    {
        locale: 'sv-SE',
        languageCode: 'sv',
        englishName: 'Swedish',
        localName: 'Svenska',
        dateFnsName: 'sv-SE',
        showSellerHelp: true,
        showBuyerHelp: true,

        dateFnsImport: async () => (await import('date-fns/locale/sv')).sv,
    },
].filter(cultureFilter);

const DefaultCulture = getCultureInfo('en-GB');
export { SupportedCultures, DefaultCulture };

export function tryGetCultureInfo(locale: string) {
    var culture = SupportedCultures.find((x) => x.locale === locale);

    if (!culture) {
        return null;
    }

    return culture;
}

export function getCultureInfo(locale: string): CultureInfo {
    var culture = tryGetCultureInfo(locale);

    if (!culture) {
        throw new Error(`Invalid language code ${locale}`);
    }

    return culture;
}
